import createIcon from '../../createIcon';

/**
 * @component @name Filter2
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA1SDFWMjFDMSAyMi4xIDEuOSAyMyAzIDIzSDE5VjIxSDNWNVpNMjEgMUg3QzUuOSAxIDUgMS45IDUgM1YxN0M1IDE4LjEgNS45IDE5IDcgMTlIMjFDMjIuMSAxOSAyMyAxOC4xIDIzIDE3VjNDMjMgMS45IDIyLjEgMSAyMSAxWk0yMSAxN0g3VjNIMjFWMTdaTTE3IDEzSDEzVjExSDE1QzE2LjEgMTEgMTcgMTAuMTEgMTcgOVY3QzE3IDUuODkgMTYuMSA1IDE1IDVIMTFWN0gxNVY5SDEzQzExLjkgOSAxMSA5Ljg5IDExIDExVjE1SDE3VjEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Filter2 = createIcon('Filter2', [
  [
    'path',
    {
      d: 'M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM17 13H13V11H15C16.1 11 17 10.11 17 9V7C17 5.89 16.1 5 15 5H11V7H15V9H13C11.9 9 11 9.89 11 11V15H17V13Z',
      key: '1uk3tf',
    },
  ],
]);

export default Filter2;
